import { useState } from "react";
import { Avatar } from '@mui/material';
import { useReduxLeads } from '@Hooks/reduxLeadsHook/useReduxLeads';

export default function WhatsappBotPreview({ payload }) {

    const { currentPhoneNumber } = useReduxLeads();
    const [input, setInput] = useState("");
    const [chat, setChat] = useState([]);

const handleSendMessage = () => {
    if (!input.trim()) return;

    const text = input.trim();
    setChat(prev => [...prev, { role: "user", text }]);

    const lower = text.toLowerCase();
    let matched = null;

    for (const t of payload?.runTimeFlow?.triggerMap || []) {
        if (t.triggerType === "fallback") continue;
        if (t.triggers.some(k => lower.includes(k.toLowerCase()))) {
            matched = t;
            break;
        }
    }

    if (!matched) {
        matched = payload?.runTimeFlow?.triggerMap?.find(t => t.triggerType === "fallback");
    }

    if (!matched) return;

    playWaChain(matched.waJsonChain, matched.replyNodeId);

    setInput("");
};

const handleButtonClick = (nodeId, btnIndex) => {
    const trigger = payload.runTimeFlow.triggerMap.find(t => t.replyNodeId === nodeId);
    if (!trigger) return;

    const lastMsg = chat[chat.length - 1];
    const btn = lastMsg?.data?.buttons?.[btnIndex];
    if (!btn) return;

    // Show user click
    setChat(prev => [...prev, { role: "user", text: btn.title }]);

    const nextTrigger = payload.runTimeFlow.triggerMap.find(
        t => t.triggers.includes(btn.id)
    );
    if (!nextTrigger) return;

    playWaChain(nextTrigger.waJsonChain, nextTrigger.replyNodeId);
};


const playWaChain = (chain = [], nodeId) => {
    chain.forEach((msg, index) => {
        setTimeout(() => {

            // TEXT MESSAGE
            if (msg.type === "text") {
                setChat(prev => [
                    ...prev,
                    {
                        role: "bot",
                        text: msg.text?.body || ""
                    }
                ]);
            }

            // INTERACTIVE MESSAGE
            if (msg.type === "interactive") {
                const body = msg.interactive?.body?.text || "";
                const buttons = msg.interactive?.action?.buttons || [];

                setChat(prev => [
                    ...prev,
                    {
                        role: "interactive",
                        nodeId,
                        data: {
                            body,
                            buttons: buttons.map(b => ({
                                id: b.reply.id,
                                title: b.reply.title
                            }))
                        }
                    }
                ]);
            }

        }, 400 * index); // ⏱️ stagger messages like real chat
    });
};
    const getInitials = (string) => {
        if (!!string && string.length > 0) {
            var names = string?.split(' '),
                initials = names[0]?.substring(0, 1)?.toUpperCase();

            if (names?.length > 1) {
                initials += names[names?.length - 1]?.substring(0, 1)?.toUpperCase();
            } else {
                names = string?.split('@');
                initials = names[0]?.substring(0, 1)?.toUpperCase();

                if (names?.length > 1) {
                    initials += names[names?.length - 1]?.substring(0, 1)?.toUpperCase();
                }
            }
            return initials;
        }
        return 'N/A';
    };

    const renderAvatar = (userName) => {
        return (
            <Avatar size={'small'} sx={{ bgcolor: '#108764 !important', width: '35px', height: '35px', fontSize: '14px' }}>
                {getInitials(userName)}
            </Avatar>
        )
    }

    return (
        <div className="autoReplies-preview-wrap">
            <div className="autoReplies-phone">

                <div className="autoReplies-phone-bar">
                    <div className="autoReplies-phone-avatar">{renderAvatar(currentPhoneNumber?.verified_name)}</div>
                    <div>
                        <div className="autoReplies-phone-name">{currentPhoneNumber?.verified_name}</div>
                        <div className="autoReplies-phone-status">online · WhatsApp Business</div>
                    </div>
                    <div className="autoReplies-phone-online-dot" />
                </div>

                <div className="autoReplies-phone-body">
                    {chat.length === 0 && (
                        <div className="autoReplies-phone-empty">
                            Build your flow to see preview.
                        </div>
                    )}

                    {chat.map((msg, i) => (
                        <div key={i} className="autoReplies-wa-msg">

                            {msg.role === "bot" && (
                                <div className="autoReplies-msg-bot-row">
                                    <div className="autoReplies-msg-avatar">{renderAvatar(currentPhoneNumber?.verified_name)}</div>
                                    <div className="autoReplies-wa-bubble-bot">{msg.text}</div>
                                </div>
                            )}

                            {msg.role === "interactive" && (
                                <div className="autoReplies-msg-bot-row">
                                    <div className="autoReplies-msg-avatar">{renderAvatar(currentPhoneNumber?.verified_name)}</div>
                                    <div className="autoReplies-wa-card">
                                        {msg.data.body && <div className="autoReplies-wa-card-body">{msg.data.body}</div>}
                                        {(msg.data.buttons || []).map((btn, j) => (
                                            <div
                                                key={j}
                                                className="autoReplies-wa-btn"
                                                style={{ color: btn.color || "#1D74F5" }}
                                                onClick={() => handleButtonClick(msg.nodeId, j)}
                                            >
                                                {btn.title}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}

                            {msg.role === "user" && (
                                <div className="autoReplies-msg-user-row">
                                    <div className="autoReplies-wa-bubble-user">{msg.text}</div>
                                </div>
                            )}

                        </div>
                    ))}
                </div>

                <div className="autoReplies-phone-input-row">
                    <input
                        className="autoReplies-phone-input"
                        value={input}
                        onChange={(e) => setInput(e.target.value)}
                        placeholder="Type a message…"
                        onKeyDown={(e) => { if (e.key === "Enter") handleSendMessage(); }}
                    />
                    <div className="autoReplies-phone-send" onClick={handleSendMessage}>➤</div>
                </div>

            </div>
        </div>
    );
}